import { render, staticRenderFns } from "./ShopCheck.vue?vue&type=template&id=0b13f6fa&scoped=true&"
import script from "./ShopCheck.vue?vue&type=script&lang=js&"
export * from "./ShopCheck.vue?vue&type=script&lang=js&"
import style0 from "./ShopCheck.vue?vue&type=style&index=0&id=0b13f6fa&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b13f6fa",
  null
  
)

export default component.exports